import './weather.css'
import { useEffect, useState } from 'react'

const Weather = () => {
    const [komal, srtkomal] = useState('')
    const [komal2 ,setkomal2] = useState('indore')
    const [datats , setdatas] = useState([])
    const [eroroe, seterore] = useState(false)
    const currentdate = new Date().toLocaleDateString();
    const currenttime = new Date().toLocaleTimeString();

    const inputhand = (e) => {
        srtkomal(e.target.value)
    }

    const serchinput =() => {
        setkomal2(komal)

    }
    const bhopal =() => {
        setkomal2('bhopal')
    }

    const Ratlam =() => {
        setkomal2('Ratlam')
    }

    const London =() => {
        setkomal2('London')
    }

    const Betul =() => {
        setkomal2('Betul')
    }

    useEffect(
        () => {
            const gatapi = async () => {
                const url = `https://api.openweathermap.org/data/2.5/weather?q=${komal2}&appid=bb06465630f51482d80cdc9aa1bd627c`
                const response = await fetch(url);
                const resjs = await response.json();
                if(resjs.cod ==='404'){
                seterore(true)
                }
                else{
                    setdatas(resjs)

                }


            }


            gatapi();


        },[komal2]
        
    )

console.log(datats)

    return (
        <div className='Weather'>
        { datats.length===0 || eroroe  ? (<div>city</div>) : (
            <div>
            <div className="centerwdiv">

                <div className="leftwepart">

                    <div className="namewe"><p>the.weather</p></div>
                    <div className="degreewt">
                        <div>
                            <div className="16d">{datats?.main?.temp_max} </div>
                            <div className='ossisty'>F</div>
                        </div>

                        <div>
                            <div className="london">{datats?.name} </div>

                            <div className="timeday">{currenttime}{currentdate}</div>
                        </div>
                        <div>
                            <div className="cloudimg">
                            <img src="https://cdn-icons-png.flaticon.com/512/9830/9830107.png" alt="" />
                            </div>
                            <div className="cloudyt timeday">{datats?.weather[0]?.description
                            }</div>

                        </div>


                    </div>



                </div>
                <div className="rightpartw">
                <div className="searchloc">
                <input type="search" placeholder="Enter your laction" name="" onChange={inputhand} id="" />
                <div className="searchicon" onClick={serchinput}>search</div>
                
                
                </div>


                <div className="popularcityname">
                <div className="citynameeach"  onClick ={bhopal}>Bhopal</div>
                <div className="citynameeach" onClick ={Ratlam}>Ratlam</div>

                <div className="citynameeach"  onClick ={London}>London</div>

                <div className="citynameeach"  onClick ={Betul}>Betul</div>

                
                
                </div>
                
                <div className="bottomline">
                <hr className='bottomlineba'/>
                </div>
                
                <div className="weatherdetails">
                <div className="weathrdname">Weather Details</div>


                <div className="typeweather">
                

                <div className="cloudywet">
                <div className="wheternameandt fontweattype"> Pressure</div>
                <div className="wheternameandt fontweattype"> {datats?.main?.pressure}</div>
                </div>
                
                <div className="cloudywet">
                <div className="wheternameandt fontweattype"> Wind Speed</div>
                <div className="wheternameandt fontweattype"> {datats?.wind?.speed}%</div>
                </div>

                <div className="cloudywet">
                <div className="wheternameandt fontweattype"> HUmidity</div>
                <div className="wheternameandt fontweattype"> {datats?.main?.humidity}%</div>
                </div>

                <div className="cloudywet">
                <div className="wheternameandt fontweattype"> Visibility
                </div>
                <div className="wheternameandt fontweattype"> {datats?.visibility}</div>
                </div>
                
                
                </div>
                
                
                
                
                
                </div>

                </div>

            </div>


            
            </div>
        )}

        </div>
    );
}

export default Weather